import PropTypes from 'prop-types';

function h({ children, fontSize, color }) {
  return (
    <span
      style={{
        fontSize: fontSize || '28px',
        fontWeight: '600', // semi bold
        fontStyle: 'normal',
        fontFamily: 'Source Sans Pro',
        textDecoration: 'none',
        color: color || '#323232',
        opacity: 1,
      }}
    >
      {children}
    </span>
  );
}

export function h1(props) {
  return h({
    ...props,
    fontSize: '28px',
  });
}

export function h2(props) {
  return h({
    ...props,
    fontSize: '24px',
  });
}

export function h3(props) {
  return h({
    ...props,
    fontSize: '20px',
  });
}

export function h4(props) {
  return h({
    ...props,
    fontSize: '16px',
  });
}

export function h5(props) {
  return h({
    ...props,
    fontSize: '14px',
  });
}

h.propTypes = {
  children: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
};

h1.propTypes =
  h2.propTypes =
  h3.propTypes =
  h4.propTypes =
  h5.propTypes =
    {
      children: PropTypes.string.isRequired,
      color: PropTypes.string,
    };
